// extracted by mini-css-extract-plugin
export default {"container":"EmptyLayout_container__vo-AY"};